export enum CURRENC_YCODE {
  MXN = 'MXN',
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  BRL = 'BRL',
  ARS = 'ARS',
  CLP = 'CLP',
  HNL = 'HNL',
  COP = 'COP',
  JPY = 'JPY',
  KRW = 'KRW',
  CRC = 'CRC',
}

export enum GROUP_CODE {
  BAGS = 'BG',
  PRERESERVED_SEAT_ASSIGNMENT = 'SA',
  INFLIGHT_ENTERTAINMENT = 'IE',
  TRAVEL_SERVICES = 'TS',
  _99 = '99',
  OTHER = 'OTHER',
}

export enum PAX_TYPE {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT',
}

export enum PAX_TYPE_SHORT {
  ADULT = 'ADT',
  CHILD = 'CHD',
  INFANT = 'INF',
}

export enum PASSENGER_TYPE {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT',
}

export enum PASSENGER_TYPE {
  FULL_FARE = 'F',
  P = 'P',
  EMPLOYEE = 'E',
  S = 'S',
}

export enum ESTATUS_CHECKIN {
  HAS_CHEKIN = 1,
  READY_FOR_CHECKIN,
  NOT_DOCUMENTS,
  NO_ELEGIBLE_TO_CHECKIN,
  VERIFY_PASSPORT,
  MAX_PASSENGERS,
}

export const GROUP_RESERVATION_THRESHOLD = 9;
